import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { NEW_RELIC_SCRIPT_SET } from './types';
export default _defineProperty({}, NEW_RELIC_SCRIPT_SET, function (state, payload) {
  var currentState = state;
  currentState.newRelicScript = payload;
});